import React, { useContext } from "react";
import { PublicRoutes } from "./PublicRoutes";
import { PrivateRoute } from "./PrivateRoute";
import { TermosRoutes } from "./TermosRoutes";
import { VerificacaoRoutes } from "./VerificacaoRoutes";
import { PoliticaRoutes } from "./PoliticaPrivacidadeRoutes";
import { AuthContext } from "../contexts/AuthContext";
import { DataLoading } from "../components/loading";
import { SatisfacaoRoutes } from "./FormulariosRoutes";
import { AtualizarCadastroRoutes } from "./AtualizarCadastroRoutes";

// ROTAS
const Routes = () => {
  const { session, loading } = useContext(AuthContext);

  // CONFIRMAÇÕES PENDENTES
  const hasTerms = session?.termos_pendentes?.length > 0 ? true : false;
  const hasPolicy = session?.politicas_privacidade_pendentes?.length > 0 ? true : false;
  const hasForms = session?.formularios_pendentes?.length > 0 ? true : false;
  const updatedRegistration = session?.cadastro_atualizado ?? true;

  if (loading)
    return (
      <div className="image-loading">
        <DataLoading />
      </div>
    );

  if (session?.logado) {
    if (!session?.verificado) {
      // DOIS FATORES
      return <VerificacaoRoutes />;
    } else if (hasPolicy) {
      // POLÍTICA DE PRIVACIDADE
      return <PoliticaRoutes />;
    } else if (hasTerms) {
      // TERMOS DE CIÊNCIA
      return <TermosRoutes />;
    } else if (hasForms) {
      // FORMULÁRIOS
      return <SatisfacaoRoutes />;
    } else if (!updatedRegistration) {
      // CADASTRO ATUALIZADO
      return <AtualizarCadastroRoutes />;
    } else {
      // AUTENTICADO
      return <PrivateRoute />;
    }
  } else {
    // NÃO AUTENTICADO
    return <PublicRoutes />;
  }
};

export { Routes };
